module.exports = __webpack_public_path__ + "static/rod_of_resurrection-b186a0182fe3e6ca35aeeb6b83a69480.jpeg";